/**
 * Gestion de l'affichage des variantes en stock sur les pages collection
 * - Desktop: affichage au hover
 * - Mobile: affichage uniquement quand le filtre "has stock = 1" est actif
 */

(function() {
  'use strict';

  const log = (typeof window !== 'undefined' && window.DEBUG_VARIANTS) ? (...args) => console.log(...args) : () => {};

  // Vérifier si on est sur une page collection
  function isCollectionPage() {
    const isCollection = document.body.classList.contains('template-collection') || 
           window.location.pathname.includes('/collections/') ||
           document.querySelector('.collection') !== null;
    log('[Variants Stock] Page collection détectée:', isCollection, window.location.pathname);
    return isCollection;
  }
  
  if (isCollectionPage()) {
    log('[Variants Stock] Script initialisé sur page collection');
    
    // Fonction pour vérifier si l'URL de la collection contient "has_stock-1" dans le pathname
    function isCollectionHasStockUrl() {
      const pathname = window.location.pathname;
      const hasStock = pathname.includes('has_stock-1') || pathname.includes('has-stock-1');
      log('[Variants Stock] Vérification pathname collection has_stock-1:', hasStock, pathname);
      return hasStock;
    }

    // Fonction pour vérifier si le filtre "has stock = 1" est actif
    function isHasStockFilterActive() {
      log('[Variants Stock] Vérification du filtre has_stock...');
      
      // NOUVEAU: Vérifier d'abord si l'URL de la collection contient "has_stock-1"
      if (isCollectionHasStockUrl()) {
        log('[Variants Stock] ✅ Collection has_stock-1 détectée dans l\'URL!');
        return true;
      }
      
      // Vérifier dans les checkboxes de filtres
      const filterCheckboxes = document.querySelectorAll('.filter-checkbox:checked');
      for (let checkbox of filterCheckboxes) {
        const filterOption = checkbox.closest('.filter-option');
        const filterItem = checkbox.closest('.filter-item');
        
        if (filterOption && filterItem) {
          const filterType = filterOption.dataset.filterType;
          const filterValue = filterOption.dataset.filterValue;
          const metafieldKey = filterItem.dataset.metafieldKey || '';
          
          // Vérifier si c'est un filtre metafield pour has_stock avec la valeur "1" ou "has-stock"
          if (filterType === 'metafield') {
            // Vérifier si le metafieldKey correspond à has_stock ou is_in_stock
            if (metafieldKey === 'has_stock' || metafieldKey === 'has-stock' || metafieldKey === 'is_in_stock' || metafieldKey === 'is-in-stock') {
              // Vérifier si la valeur est "1" ou "has-stock" (après handleize)
              if (filterValue === '1' || filterValue === 'has-stock' || filterValue === 'has_stock') {
                return true;
              }
            }
            // Vérifier aussi par le label du filtre (au cas où)
            const label = filterOption.querySelector('.filter-option__text');
            if (label && (label.textContent.toLowerCase().includes('has stock') || label.textContent.toLowerCase().includes('en stock'))) {
              if (filterValue === '1' || filterValue === 'has-stock' || filterValue === 'has_stock') {
                return true;
              }
            }
          }
        }
      }
      
      // Vérifier dans les paramètres de l'URL - format: filter.p.m.custom.has_stock=1 (uniquement =1, pas =0)
      const urlParams = new URLSearchParams(window.location.search);
      log('[Variants Stock] Paramètres URL:', Array.from(urlParams.entries()));
      
      for (let [key, value] of urlParams.entries()) {
        log('[Variants Stock] Vérification paramètre:', key, '=', value);
        // Format: filter.p.m.custom.has_stock=1 ou filter.p.m.custom.has-stock=1
        // Vérifier si la clé contient "has_stock" ou "has-stock" et la valeur est EXACTEMENT "1" (pas "0")
        if ((key.includes('has_stock') || key.includes('has-stock'))) {
          if (value === '1') {
            log('[Variants Stock] ✅ Filtre has_stock=1 détecté dans URL!');
            return true;
          }
          // Si has_stock=0, retourner explicitement false
          if (value === '0') {
            log('[Variants Stock] ❌ Filtre has_stock=0 détecté, masquage des variantes');
            return false;
          }
        }
        // Format alternatif avec is_in_stock
        if ((key.includes('is_in_stock') || key.includes('is-in-stock'))) {
          if (value === '1') {
            log('[Variants Stock] ✅ Filtre is_in_stock=1 détecté dans URL!');
            return true;
          }
          if (value === '0') {
            log('[Variants Stock] ❌ Filtre is_in_stock=0 détecté, masquage des variantes');
            return false;
          }
        }
        // Format alternatif: filter.v.metafields.custom.is_in_stock=1 ou filter.p.m.custom.has_stock=1
        if (key.includes('metafield') && (key.includes('has_stock') || key.includes('has-stock') || key.includes('is_in_stock') || key.includes('is-in-stock'))) {
          // Vérifier que la valeur est bien "1" et non "0"
          if (value === '1' || value === 'has-stock' || value === 'has_stock') {
            log('[Variants Stock] ✅ Filtre metafield=1 détecté dans URL!');
            return true;
          }
          if (value === '0') {
            log('[Variants Stock] ❌ Filtre metafield=0 détecté, masquage des variantes');
            return false;
          }
        }
      }
      
      log('[Variants Stock] ❌ Filtre has_stock non détecté');
      return false;
    }

    // Fonction pour afficher/masquer les variantes en stock
    function toggleVariantsDisplay(show) {
      const variantElements = document.querySelectorAll('.card__variants-in-stock');
      log('[Variants Stock] toggleVariantsDisplay appelé avec show=', show, '- éléments trouvés:', variantElements.length);
      variantElements.forEach((element, index) => {
        const variantsData = element.dataset.variantsInStock;
        log(`[Variants Stock] Élément ${index + 1}:`, {
          hasData: !!variantsData,
          data: variantsData,
          productId: element.dataset.productId
        });
        // Vérifier si l'élément a des variantes en stock
        if (variantsData && variantsData.trim() !== '') {
          // Afficher uniquement si show est true ET qu'il y a des variantes
          if (show) {
            log(`[Variants Stock] ✅ Affichage de l'élément ${index + 1} avec variantes:`, variantsData);
            // Retirer le !important et afficher
            element.style.removeProperty('display');
            element.style.removeProperty('visibility');
            element.style.display = 'block';
            element.style.visibility = 'visible';
            // Forcer l'affichage avec !important pour surcharger tout style précédent
            element.style.setProperty('display', 'block', 'important');
            element.style.setProperty('visibility', 'visible', 'important');
          } else {
            log(`[Variants Stock] ❌ Masquage de l'élément ${index + 1}`);
            element.style.display = 'none';
            element.style.visibility = 'hidden';
            // Forcer aussi avec !important via setProperty
            element.style.setProperty('display', 'none', 'important');
            element.style.setProperty('visibility', 'hidden', 'important');
          }
        } else {
          // Si pas de variantes en stock, toujours masquer
          log(`[Variants Stock] ⚠️ Pas de variantes pour l'élément ${index + 1}`);
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
        }
      });
    }

    // Fonction pour gérer le hover sur desktop
    function setupDesktopHover() {
      const cardWrappers = document.querySelectorAll('.card-wrapper');
      
      cardWrappers.forEach(cardWrapper => {
        const variantElement = cardWrapper.querySelector('.card__variants-in-stock');
        
        if (variantElement) {
          const variantsData = variantElement.dataset.variantsInStock || '';
          // Ne gérer le hover que si l'élément a des variantes en stock
          if (variantsData.trim() !== '') {
            cardWrapper.addEventListener('mouseenter', function() {
              // Vérifier qu'on est bien sur desktop ET que le filtre has_stock est actif
              if (window.innerWidth >= 750 && isHasStockFilterActive()) {
                variantElement.style.removeProperty('display');
                variantElement.style.removeProperty('visibility');
                variantElement.style.display = 'block';
                variantElement.style.visibility = 'visible';
                // Forcer l'affichage avec !important
                variantElement.style.setProperty('display', 'block', 'important');
                variantElement.style.setProperty('visibility', 'visible', 'important');
              }
            });
            
            cardWrapper.addEventListener('mouseleave', function() {
              variantElement.style.display = 'none';
              variantElement.style.visibility = 'hidden';
              variantElement.style.setProperty('display', 'none', 'important');
              variantElement.style.setProperty('visibility', 'hidden', 'important');
            });
          }
        }
      });
    }

    // Fonction pour gérer l'affichage sur mobile selon le filtre
    function setupMobileFilter() {
      // Vérifier si on est sur mobile
      function isMobile() {
        return window.innerWidth < 750;
      }

      // Fonction pour mettre à jour l'affichage selon le filtre
      function updateMobileDisplay() {
        const hasStockActive = isHasStockFilterActive();
        const mobile = isMobile();
        log('[Variants Stock] updateMobileDisplay - Mobile:', mobile, 'Filtre actif:', hasStockActive);
        
        // Si le filtre has_stock n'est pas actif, cacher les variantes partout (mobile ET desktop)
        if (!hasStockActive) {
          log('[Variants Stock] ❌ Filtre has_stock non actif - variantes totalement cachées');
          toggleVariantsDisplay(false);
          return;
        }
        
        if (mobile) {
          // Sur mobile, afficher si le filtre est actif
          toggleVariantsDisplay(true);
        } else {
          // Sur desktop, masquer par défaut (le hover gérera l'affichage car le filtre est actif)
          toggleVariantsDisplay(false);
        }
      }

      // Écouter les changements de filtres avec délégation d'événements
      document.addEventListener('change', function(e) {
        if (e.target.classList.contains('filter-checkbox')) {
          setTimeout(updateMobileDisplay, 100);
        }
      });
      
      // Écouter aussi les boutons d'application de filtres
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('filter-apply-btn')) {
          setTimeout(updateMobileDisplay, 200);
        }
      });

      // Écouter les changements de taille de fenêtre
      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateMobileDisplay, 250);
      });

      // Initialiser l'affichage
      updateMobileDisplay();
    }

    // Initialiser quand le DOM est prêt
    function initialize() {
      log('[Variants Stock] Initialisation du script...');
      const variantElements = document.querySelectorAll('.card__variants-in-stock');
      log('[Variants Stock] Éléments .card__variants-in-stock trouvés:', variantElements.length);
      
      // Vérifier IMMÉDIATEMENT si le filtre est actif et cacher/afficher les variantes selon le cas
      const hasStockActive = isHasStockFilterActive();
      log('[Variants Stock] État initial du filtre has_stock:', hasStockActive);
      
      // Si le filtre n'est pas actif, cacher TOUTES les variantes immédiatement
      if (!hasStockActive) {
        log('[Variants Stock] ❌ Filtre has_stock non actif - masquage immédiat de toutes les variantes');
        variantElements.forEach(element => {
          element.style.display = 'none';
          element.style.visibility = 'hidden';
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
        });
      } else {
        // Si le filtre est actif, laisser setupMobileFilter gérer l'affichage selon mobile/desktop
        log('[Variants Stock] ✅ Filtre has_stock actif - laisser setupMobileFilter gérer l\'affichage');
      }
      
      // Debug: vérifier les card-wrapper
      const cardWrappers = document.querySelectorAll('.card-wrapper');
      log('[Variants Stock] Card wrappers trouvés:', cardWrappers.length);
      
      // Debug: vérifier si les éléments sont dans le DOM mais peut-être cachés
      if (variantElements.length === 0 && cardWrappers.length > 0) {
        log('[Variants Stock] ⚠️ Aucun élément .card__variants-in-stock trouvé mais', cardWrappers.length, 'card-wrapper présents');
        // Vérifier le premier card-wrapper
        const firstCard = cardWrappers[0];
        log('[Variants Stock] Premier card-wrapper HTML:', firstCard.innerHTML.substring(0, 500));
      }
      
      setupDesktopHover();
      setupMobileFilter();
    }
    
    if (document.readyState === 'loading') {
      log('[Variants Stock] DOM en cours de chargement, attente de DOMContentLoaded...');
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      // Si le DOM est déjà chargé, initialiser immédiatement
      log('[Variants Stock] DOM déjà chargé, initialisation immédiate');
      initialize();
      // Mais aussi réinitialiser après un court délai pour être sûr que tout est prêt
      setTimeout(function() {
        log('[Variants Stock] Réinitialisation après délai...');
        initialize();
      }, 500);
    }

    // Réinitialiser après les filtres AJAX (si applicable)
    const originalFilterFunction = window.filterProductsClientSide;
    if (typeof originalFilterFunction === 'function') {
      window.filterProductsClientSide = function() {
        originalFilterFunction.apply(this, arguments);
        setTimeout(function() {
          log('[Variants Stock] Réinitialisation après filterProductsClientSide');
          setupDesktopHover();
          setupMobileFilter();
        }, 100);
      };
    }
    
    // Écouter les événements de mise à jour AJAX des produits
    document.addEventListener('facetFiltersUpdated', function() {
      setTimeout(function() {
        log('[Variants Stock] Réinitialisation après facetFiltersUpdated');
        setupDesktopHover();
        setupMobileFilter();
      }, 500);
    });
    
    // Intercepter les remplacements innerHTML sur #product-grid
    const productGridElement = document.getElementById('product-grid');
    if (productGridElement) {
      const originalInnerHTMLSetter = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML').set;
      Object.defineProperty(productGridElement, 'innerHTML', {
        set: function(value) {
          originalInnerHTMLSetter.call(this, value);
          setTimeout(function() {
            log('[Variants Stock] Réinitialisation après innerHTML sur product-grid');
            setupDesktopHover();
            setupMobileFilter();
          }, 200);
        },
        get: function() {
          return originalInnerHTMLSetter ? originalInnerHTMLSetter.call(this) : '';
        }
      });
    }
    
    // Intercepter les mises à jour AJAX de la grille de produits
    const originalUpdateProductGrid = window.FacetFiltersForm?.updateProductGrid;
    if (originalUpdateProductGrid) {
      window.FacetFiltersForm.updateProductGrid = function(doc) {
        originalUpdateProductGrid.apply(this, arguments);
        setTimeout(function() {
          log('[Variants Stock] Réinitialisation après updateProductGrid');
          setupDesktopHover();
          setupMobileFilter();
        }, 300);
      };
    }

    // Observer pour les changements dynamiques du DOM (si des produits sont ajoutés dynamiquement)
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              // Vérifier si un élément .card__variants-in-stock a été ajouté
              if (node.classList && node.classList.contains('card__variants-in-stock')) {
                shouldReinit = true;
              }
              // Vérifier si un card-wrapper a été ajouté
              if (node.classList && node.classList.contains('card-wrapper')) {
                shouldReinit = true;
              }
              // Vérifier si un grid__item (produit) a été ajouté
              if (node.classList && node.classList.contains('grid__item')) {
                shouldReinit = true;
              }
              // Vérifier si le ProductGridContainer a été mis à jour
              if (node.id === 'ProductGridContainer' || node.id === 'product-grid') {
                shouldReinit = true;
              }
              // Vérifier récursivement
              if (node.querySelector && (node.querySelector('.card__variants-in-stock') || node.querySelector('.card-wrapper') || node.querySelector('.grid__item'))) {
                shouldReinit = true;
              }
            }
          });
        }
        // Vérifier aussi les changements d'attributs sur ProductGridContainer
        if (mutation.type === 'childList' && mutation.target.id === 'ProductGridContainer') {
          shouldReinit = true;
        }
      });
      if (shouldReinit) {
        log('[Variants Stock] Changement détecté dans le DOM, réinitialisation...');
        setTimeout(function() {
          setupDesktopHover();
          setupMobileFilter();
        }, 200);
      }
    });

    // Observer le ProductGridContainer et le body
    const productGrid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (productGrid) {
      observer.observe(productGrid, {
        childList: true,
        subtree: true,
        attributes: false
      });
    }
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();

